<template>
  <div>
    <EnterPuk
      v-if="!idLevelUpgraded"
      :accountId="accountId"
      :onIdLevelIsUpgraded="idLevelIsUpgraded"
      :pukSmsResult="pukSmsResult"
      @gotoChoice="gotoChoice"
    ></EnterPuk>
    <PukConfirmed v-if="idLevelUpgraded" :username="username"></PukConfirmed>
  </div>
</template>

<script lang="ts" setup>
import EnterPuk from '@/components/account-management/idlevelupgrade/EnterPuk.vue'
import PukConfirmed from '@/components/account-management/idlevelupgrade/PukConfirmed.vue'
import { type PropType, ref } from 'vue'
import { type PukSmsResult } from '@/types/account-management/AccountManagementTypes'

defineProps({
  pukSmsResult: {
    type: Object as PropType<PukSmsResult> | null,
    required: false,
    default: null
  },
  accountId: {
    type: String,
    required: false,
    default: ''
  },
  username: {
    type: String,
    required: false
  }
})

const emit = defineEmits<{
  gotoChoice: any
}>()

const idLevelUpgraded = ref(false)

const idLevelIsUpgraded = (): void => {
  idLevelUpgraded.value = true
}

const gotoChoice = (): void => {
  emit('gotoChoice')
}
</script>
<style lang="scss" scoped>
//Do not remove this comment. Reason is that with empty style section the various scss-styles which are imported
// in vue.config.js are not used (see https://github.com/vuejs/vue-cli/issues/5188)
</style>
